<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<!-- 기간 단위 -->
					<el-col :span="2">
						<select-combo
							:label="getMessage_('QWCC002008')"
							paramKey="period"
							:options="searchCategory"
							:propData="searchParams.period"
							@commChange="setSearchParam"
							:showAll="false"
						></select-combo>
					</el-col>
					<!-- 검사기간 -->
					<el-col :span="3">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001224') }}</span>
							<el-date-picker
								:value="searchParams.strDt"
								@input="value => setSearchParam({ key: 'strDt', value })"
								:type="searchParams.period === 'month' ? 'year' : 'month'"
								:value-format="searchParams.period === 'month' ? 'yyyy' : 'yyyyMM'"
								:placeholder="getMessage_('QWCC001224')"
							/>
						</div>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
export default {
	props: { scrId: { type: String, default: '' } },
	components: { SelectCombo },
	data() {
		return {
			searchCategory: []
		};
	},
	async created() {
		this.searchCategory = [
			{ label: this.getMessage_('QWCC002006'), value: 'day' },
			{ label: this.getMessage_('QWCC002007'), value: 'month' }
		];
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
			if (key === 'period') {
				const result = value === 'month' ? this.$moment().format('YYYY') : this.$moment().format('YYYYMM');
				this.setSearchParam_({ key: 'strDt', value: result });
			}
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isMmcAdmin) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				await this.getList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$emit('doLoad');
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
